<div class="recent-orders">
    <div class="title-buttons">
        <strong>{{ title }}</strong>
    </div>
    <br />
    <br />
    <p *ngIf="loading; else testimonialForm">Loading ...</p>
    <ng-template #testimonialForm>
        <div class="table-responsive">
            <div class="form-page-block">
                <div class="card">
                    <div class="card-header">
                        <span>&nbsp;</span>
                    </div>
                    <div class="card-body">
                        <form class="form-page" [formGroup]="form" (ngSubmit)="save()">
                            <input type="hidden" formControlName="id" />
                            <div class="form-group">
                                <label>Display Name <span class="required">*</span> </label>
                                <input type="text" class="form-control" formControlName="displayName" />
                            </div>
                            <div class="form-group mt-3">
                                <label>Job Title <span class="required">*</span> </label>
                                <input type="text" class="form-control" formControlName="jobTitle" />
                            </div>
                            <div class="form-group mt-3">
                                <label>Company <span class="required">*</span> </label>
                                <input type="text" class="form-control" formControlName="company" />
                            </div>
                            <div class="form-group mt-3">
                                <label>Location <span class="required">*</span> </label>
                                <input type="text" class="form-control" formControlName="location" />
                            </div>
                            <div class="form-group mt-3">
                                <label>Comment <span class="required">*</span> </label>
                                <textarea class="form-control" formControlName="comment" rows="5"></textarea>
                            </div>
                            <div class="form-group mt-3">
                                <label>Profile Photo <span *ngIf="!testimonialId" class="required">*</span> </label><br>
                                <input type="file" formControlName="photo" (change)="onChangeFile($event)" accept="image/*" />
                            </div>
                            <div class="form-group mt-3" *ngIf="previewUrl || existingPhotoUrl">
                                <label>Preview</label><br>
                                <img *ngIf="previewUrl" [src]="previewUrl" style="max-height: 120px; max-width: 200px; object-fit: contain; border-radius: 50%;" />
                                <img *ngIf="!previewUrl && existingPhotoUrl" [src]="existingPhotoUrl" style="max-height: 120px; max-width: 200px; object-fit: contain; border-radius: 50%;" />
                            </div>
                            <div class="button-set mt-3">
                                <button [disabled]="form.invalid || submitting" class="btn btn-success" id="btn-submit" type="submit">
                                    Save
                                </button>
                                &nbsp;
                                <span *ngIf="submitting">saving ...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
